
import { Component } from 'vue-property-decorator'
import ListBase from '@/lib/listbase'
import PageRequest from '@/store/entities/page-request'
import ListView from '@/components/helper/list-view.vue'
import FormBase from '@/components/helper/form-base.vue'
import ManufacturerModelForm from './manufacter-model-form.vue'


class PageManufacturerModelRequest extends PageRequest {
}

@Component({
    components: {
        ListView,
        FormBase,
        ManufacturerModelForm
    }
})
export default class ManufacturerModel extends ListBase {
    entity: string = 'manufacturer-models'
    pagerequest: PageManufacturerModelRequest = new PageManufacturerModelRequest()

    columns = [
        this.gCol('model', 'Modelo', 'text'),
        this.gCol('manufacturer.name', 'Marca', 'text'),
        this.defaultActions()
    ]

    edit() {
        this.modalShow = !this.modalShow
    }
    create() {
        this.modalShow = !this.modalShow
    }

    async afterSave() {
        const list: any = this.$refs.listView
        if (list) {
            await list.getpage()
        }
    }

    mounted() {
    }

    created() {
    }
}
